"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _requestErrorItem = _interopRequireDefault(require("./request-error-item"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var RequestError = /*#__PURE__*/function () {
  function RequestError(options) {
    (0, _classCallCheck2.default)(this, RequestError);
    (0, _defineProperty2.default)(this, "name", 'RequestError');
    (0, _defineProperty2.default)(this, "message", void 0);
    (0, _defineProperty2.default)(this, "status", void 0);
    (0, _defineProperty2.default)(this, "statusText", void 0);
    (0, _defineProperty2.default)(this, "errors", []);
    (0, _defineProperty2.default)(this, "meta", null);
    this.message = options.message;
    this.status = options.status;
    this.statusText = options.statusText;
    var responseBody = options.responseBody; // Handle empty/invalid response

    if (!responseBody || !Array.isArray(responseBody.errors)) {
      var defaultError = new _requestErrorItem.default({
        detail: 'An unknown error has occurred. Please try again later or contact Setapp support team'
      });
      this.errors.push(defaultError);
      return;
    } // Skip empty meta


    if (responseBody.meta) {
      this.meta = responseBody.meta;
    }

    this.errors = responseBody.errors.map(function (error) {
      return new _requestErrorItem.default(error);
    });
  }
  /**
   * @param {Response} response response object returned by fetch()
   * @param {object} [responseBody] parsed response body
   * @returns {RequestError}
   */


  (0, _createClass2.default)(RequestError, [{
    key: "getSimplifiedErrors",

    /**
     * Returns simple error object in format
     * {
     *   genericError: 'error text',
     *   fieldsErrors: {
     *     fieldName: 'error text'
     *   }
     * }
     * @returns {object}
     */
    value: function getSimplifiedErrors() {
      return this.errors.reduce(function (allErrors, error) {
        if (error.field) {
          return _objectSpread({}, allErrors, {
            fieldsErrors: _objectSpread({}, allErrors.fieldsErrors, (0, _defineProperty2.default)({}, error.field, error.message))
          });
        }

        return _objectSpread({}, allErrors, {
          genericError: error.message
        });
      }, {});
    }
    /**
     * Returns generic form error
     */

  }, {
    key: "getGenericError",
    value: function getGenericError() {
      var _this$errors$filter = this.errors.filter(function (error) {
        return !error.field;
      }),
          _this$errors$filter2 = (0, _slicedToArray2.default)(_this$errors$filter, 1),
          _this$errors$filter2$ = _this$errors$filter2[0],
          error = _this$errors$filter2$ === void 0 ? null : _this$errors$filter2$;

      return error;
    }
    /**
     * Returns error for a particular field
     */

  }, {
    key: "getFieldError",
    value: function getFieldError(field) {
      var _this$errors$filter3 = this.errors.filter(function (error) {
        return error.field === field;
      }),
          _this$errors$filter4 = (0, _slicedToArray2.default)(_this$errors$filter3, 1),
          _this$errors$filter4$ = _this$errors$filter4[0],
          error = _this$errors$filter4$ === void 0 ? null : _this$errors$filter4$;

      return error;
    }
    /**
     * Returns meta data for a particular field
     */

  }, {
    key: "getFieldMeta",
    value: function getFieldMeta(field) {
      if (this.meta && this.meta[field]) {
        return this.meta[field];
      }

      return null;
    }
    /**
     * Returns true if there's an error for a given field name
     */

  }, {
    key: "hasFieldError",
    value: function hasFieldError(field) {
      return Boolean(this.getFieldError(field));
    }
    /**
     * Returns all request errors
     */

  }, {
    key: "getAll",
    value: function getAll() {
      return this.errors;
    }
  }], [{
    key: "create",
    value: function create(response, responseBody) {
      return new RequestError({
        message: 'Request failed',
        status: response.status,
        statusText: response.statusText,
        responseBody: responseBody
      });
    }
  }]);
  return RequestError;
}();

var _default = RequestError;
exports.default = _default;
//# sourceMappingURL=request-error.js.map